import axiosClient from "../axiosClient";

export const addSingll_skill_up_User = async (data) => {
    return await axiosClient.post(`/add_skill_user`, data);
};

export const getUsers = async () => {
    return await axiosClient.get('/get_all_user');
};

export const getUsersMore = async (page, data) => {
    return await axiosClient.post(`/get_all_user_v2?page=${page}`, data);
};

export const getUsersSeach = async (s1, s2) => {
    return await axiosClient.post(`/get_all_user_v2?search=${encodeURIComponent(s1)}&page=${s2}`);
};

export const getUserSort = async (data, page) => {
    return await axiosClient.post(`/get_all_user_v2?page=${page}`, data);
};
export const getAllUserSk = async (s1, s2) => {
    return await axiosClient.get(`/get_all_user_report`);
};

export const getUserData = async (id) => {
    return await axiosClient.get(`/get_user_course_info/${id}`);
};

export const changeUserStatus = async (data) => {
    return await axiosClient.put(`/update_user_status`, data);
};

export const deleteUser = async (id) => {
    return await axiosClient.delete(`/delete_user/${id}`);
};

export const deleteUserCourse = async (data) => {
    return await axiosClient.post(`/remove_user_from_course`, data);
};

export const upgradeMemberShip = async (data) => {
    return await axiosClient.put(`/update_membership`, data);
};

/** Pre-collage User */

export const getAllUserPreReport = async (s1, s2) => {
    return await axiosClient.get(`/get_all_pre_user_report`);
};
export const uploadUser = async (data) => {
    return await axiosClient.post(`/add_pre_clg_user`, data);
};

export const addSingleUser = async (data) => {
    return await axiosClient.post(`/add_single_pre_clg_user`, data);
};

export const editUser = async (data) => {
    return await axiosClient.put(`/pre_clg_edit_user`, data);
};

export const getUsersPreCollege = async () => {
    return await axiosClient.get('/get_all_pre_clg_user');
};

export const getUsersPreCollege_v2 = async () => {
    return await axiosClient.post('/get_all_pre_clg_user_v2');
};

export const getUserPreSort = async (data, page) => {
    return await axiosClient.post(`/get_all_pre_clg_user_v2?page=${page}`, data);
};

export const getUsersPreSeach = async (s1, s2) => {
    return await axiosClient.post(`/get_all_pre_clg_user_v2?search=${encodeURIComponent(s1)}&page=${s2}`);
};

export const getUsersPreMore = async (page, data) => {
    return await axiosClient.post(`/get_all_pre_clg_user_v2?page=${page}`, data);
};

export const getContributor = async () => {
    return await axiosClient.get('/getContributor');
};

export const changeUserStatusPreCollege = async (data) => {
    return await axiosClient.put(`/pre_clg_update_user_status`, data);
};

export const verifyUserPreCollege = async (data) => {
    return await axiosClient.put(`/pre_clg_user_verify`, data);
};
export const verifyUserCertificates = async (data) => {
    return await axiosClient.put(`/cert_user_verify`, data);
};
export const verifyUserDl = async (data) => {
    return await axiosClient.put(`/dl_user_verify`, data);
};

export const deleteUserPreCollege = async (id) => {
    return await axiosClient.delete(`/pre_clg_delete_user/${id}`);
};

export const getUserEnrolledCourse = async (id) => {
    return await axiosClient.get(`/get_user_enroll_course/${id}`);
};

export const sendMailPreCollegeUser = async (data) => {
    return await axiosClient.post(`/send_mail_pre_clg_user`, data);
};

export const deleteUserCoursePreCollege = async (data) => {
    return await axiosClient.post(`/pre_clg_remove_user_from_course`, data);
};

/** Career-Launch User */

export const uploadCareerUser = async (data) => {
    return await axiosClient.post(`/add_cl_user`, data);
};

export const addSingleCareerUser = async (data) => {
    return await axiosClient.post(`/add_single_cl_user`, data);
};

export const editUserCareerUser = async (data) => {
    return await axiosClient.put(`/cl_edit_user`, data);
};

export const getUsersCareer = async () => {
    return await axiosClient.get('/get_all_cl_user');
};

export const changeUserStatusCareer = async (data) => {
    return await axiosClient.put(`/cl_update_user_status`, data);
};

export const deleteUserCareer = async (id) => {
    return await axiosClient.delete(`/cl_delete_user/${id}`);
};

export const sendMailCareerUser = async (data) => {
    return await axiosClient.post(`/send_mail_cl_user`, data);
};

export const sendMailSkillUpUser = async (data) => {
    return await axiosClient.post(`/resend_mail_user`, data);
};

export const deleteUserCourseCareer = async (data) => {
    return await axiosClient.post(`/cl_remove_user_from_course`, data);
};

export const userResetPassword = async (data) => {
    return await axiosClient.put(`/reset_user_password`, data);
};

export const preCollegeUserResetPassword = async (data) => {
    return await axiosClient.put(`/preclg_reset_user_password`, data);
};

// Applications

export const getAllApplications = async () => {
    return await axiosClient.get('/application_list');
};
export const getDlManualPayment = async (data) => {
    return await axiosClient.post('/dl_manual_payment', data);
};

export const getApplicantDetailsById = async (id) => {
    return await axiosClient.get(`/view_application/${id}`);
};

export const approveRejectApplications = async (data) => {
    return await axiosClient.post('/approve_reject_application', data);
};

export const deleteApplication = async (id) => {
    return await axiosClient.delete(`/delete_application/${id}`);
}

export const resendApproveApplicationMail = async (data) => {
    return await axiosClient.post(`/resend_approve_application_mail`, data);

};

export const getAllApplicationsList = async (data) => {
    return await axiosClient.post(`/view_full_application`, data);
};

// certificates


export const getAllUserCertReport = async (s1, s2) => {
    return await axiosClient.get(`/get_all_cert_user_report`);
};

export const uploadUsercertificates = async (data) => {
    return await axiosClient.post(`/addCertUser`, data);
};


export const addSinglecertificates = async (data) => {
    return await axiosClient.post(`/add_cert_user`, data);
};

export const editcertificates = async (data) => {
    return await axiosClient.put(`/cert_edit_user`, data);
};


export const deleteUsercertificates = async (id) => {
    return await axiosClient.delete(`/cert_delete_user/${id}`);
};

export const sendMailcertificates = async (data) => {
    return await axiosClient.post(`/send_mail_cert_user`, data);
};
export const resendMailcertificates = async (data) => {
    return await axiosClient.post(`/resend_mail_cert_user`, data);
};

export const changeUserStatuscertificates = async (data) => {
    return await axiosClient.put(`/cert_update_user_status`, data);
};


export const getUserscertificates = async () => {
    return await axiosClient.get('/getCertUsers');
};

export const getUserscertificates_v2 = async () => {
    return await axiosClient.post('/get_all_cert_user_v2');
};

export const getUserCertSort = async (data, page) => {
    return await axiosClient.post(`/get_all_cert_user_v2?page=${page}`, data);
};

export const getUsersCertSeach = async (s1, s2) => {
    return await axiosClient.post(`/get_all_cert_user_v2?search=${encodeURIComponent(s1)}&page=${s2}`);
};

export const getUsersCertMore = async (page, data) => {
    return await axiosClient.post(`/get_all_cert_user_v2?page=${page}`, data);
};
export const getAllcertificates = async () => {
    return await axiosClient.get('/cert_application_list');
};

export const getUserEnrolledCert = async (id) => {
    return await axiosClient.get(`/get_cert_enroll_course/${id}`);
};
export const getAllcertificatesAppliList = async (data) => {
    return await axiosClient.post(`/cert_application`, data);
};

export const certificatesUserResetPassword = async (data) => {
    return await axiosClient.put(`/cert_reset_user_password`, data);
};

export const deleteUserCoursecertificates = async (data) => {
    return await axiosClient.post(`/cert_remove_user_from_course`, data);
};

export const getApplicantDetailsByIdcertificates = async (id) => {
    return await axiosClient.get(`/view_cert_application/${id}`);
};

export const approveRejectApplicationsCert = async (data) => {
    return await axiosClient.post('/approveRejectApplication', data);
};

export const deleteCertApplication = async (id) => {
    return await axiosClient.delete(`/deleteApp/${id}`);
}

export const resendCertApproveApplicationMail = async (data) => {
    return await axiosClient.post(`/resendAppMail `, data);
};


export const cert_status = async () => {
    return await axiosClient.put('/cert_course_status')
}

export const certEditStatus = async (data) => {
    return await axiosClient.put('/update_cert_status', data)
}

export const getUser_EnrolledCert = async (id) => {
    return await axiosClient.get(`/get_user_enroll_cert_course/${id}`);
};

export const getCertificateApplication = async (data) => {
    return await axiosClient.post(`/get_certificates`, data);
}

// DL Program

export const getUserDl = async () => {
    return await axiosClient.post('/get_all_dl_user');
};

export const dlUserResetPassword = async (data) => {
    return await axiosClient.put(`/dl_reset_user_password`, data);
};

export const deleteUserdl = async (id) => {
    return await axiosClient.delete(`/dl_delete_user/${id}`);
};

export const changeUserStatusDl = async (data) => {
    return await axiosClient.put(`/dl_update_user_status`, data);
};

export const getAllDl = async () => {
    return await axiosClient.get('/dl_application_list');
};

export const getAllDlList = async (data) => {
    return await axiosClient.post(`/dl_application`, data);
};

export const resendDlApproveApplicationMail = async (data) => {
    return await axiosClient.post(`/resendDlAppMail`, data);
};

export const deleteDlApplication = async (id) => {
    return await axiosClient.delete(`/deleteDlApp/${id}`);
}

export const getApplicantDetailsByIdDl = async (id) => {
    return await axiosClient.get(`/view_dl_application/${id}`);
};

export const getAllDlLists = async () => {
    return await axiosClient.get('/dl_application_list');
};

export const approveRejectApplicationsDl = async (data) => {
    return await axiosClient.post('/dl_approve_reject_application', data);
};

export const uploadUserDl = async (data) => {
    return await axiosClient.post(`/addDlUser`, data);
};

export const addSingleDl = async (data) => {
    return await axiosClient.post(`/add_dl_user`, data);
};

export const editUserDl = async (data) => {
    return await axiosClient.put(`/dl_edit_user`, data);
};

export const sendMailDl = async (data) => {
    return await axiosClient.post(`/reSend_mail_dl_user`, data);
};

//  contributors resetPassword
export const contributorsResetPassword = async (data) => {
    return await axiosClient.put(`/reset_admin_password`, data);
};

// contributors delete 
export const deleteContributors = async (id) => {
    return await axiosClient.delete(`/delete_admin/${id}`);
};

export const getUsersDL_v2 = async () => {
    return await axiosClient.post('/get_all_dl_user_v2');
};

export const getUserDlSort = async (data, page) => {

    return await axiosClient.post(`/get_all_dl_user_v2?page=${page}`, data);
};

export const getUsersDlSeach = async (s1, s2) => {
    return await axiosClient.post(`/get_all_dl_user_v2?search=${encodeURIComponent(s1)}&page=${s2}`);
};

export const getUsersDlMore = async (page, data) => {
    return await axiosClient.post(`/get_all_dl_user_v2?page=${page}`, data);
}

export const getAllUserDLReport = async (s1, s2) => {
    return await axiosClient.get(`/get_all_dl_user_report`);
};

export const deleteUserProgramDL = async (data) => {
    return await axiosClient.post(`/dl_remove_user_from_course`, data);
};

export const getUsersDL_applicant_v2 = async () => {
    return await axiosClient.post('/get_all_dl_applicant_user_v2');
};

export const getUsersDl_applicant_Seach = async (s1, s2) => {
    return await axiosClient.post(`/get_all_dl_applicant_user_v2?search=${encodeURIComponent(s1)}&page=${s2}`);
};

export const getAllUserDL_applicant_Report = async (s1, s2) => {
    return await axiosClient.get(`/get_all_dl_applicant_user_report`);
};

export const getUserDl_applicant_Sort = async (data, page) => {
    return await axiosClient.post(`/get_all_dl_applicant_user_v2?page=${page}`, data);
};
export const getUsersDl_applicant_More = async (page, data) => {
    return await axiosClient.post(`/get_all_dl_applicant_user_v2?page=${page}`, data);
}